// V1.14 White-Label: zentrales Mapping von Branding-Farb-Schlüsseln auf die
// CSS-Custom-Properties unter `.vitals{}` (siehe styles/vitals.css). EINE Quelle
// der Wahrheit — sowohl die Style-Injektion als auch evtl. künftige Konsumenten
// referenzieren dieses Objekt, statt die Var-Namen zu duplizieren.
export const BRANDING_TOKENS = {
  primary: '--woodland',
  accent: '--cream',
  online: '--st-online',
  offline: '--st-offline',
  warn: '--st-warn',
  ink: '--ink',
  page: '--page',
  surface: '--surface',
} as const

export type ColorKey = keyof typeof BRANDING_TOKENS

export interface BrandingConfig {
  appName: string | null
  logo: string | null
  colors: Partial<Record<ColorKey, string | null>>
}
